import styled from "styled-components";
import FlexContainer from "../FlexContainer";
import MrocketIcon from "../icons/Mrocket";
import Button, {ButtonColor, ButtonVariant} from "../Button";
import React from "react";
import ButtonLink from "../ButtonLink";
import Link from "../Link";
import TextContainer from "../TextContainer";

const NavFlexContainer = styled(FlexContainer)`
  margin-left: 10px;
`

const Nav: React.FunctionComponent<React.HTMLAttributes<HTMLDivElement>> = (props) => {
    return <div {...props}>
        <FlexContainer flex={1} justifyContent={"center"}>
            <Link target={"_blank"} href={"https://mrocket.ru"}>
                <NavFlexContainer gap={10}>
                    <MrocketIcon width={40} height={40} color={"var(--main-logo)"}/>
                    <TextContainer fontSize={"28px"} fontWeight={800}
                                   color={"var(--main-logo)"}>MROCKET | Импортер для crmamovsklife</TextContainer>
                </NavFlexContainer>
            </Link>
        </FlexContainer>
    </div>
}


const Navbar = styled(Nav)`
  position: sticky;
  top: 16px;
  left: 0;
  padding: 0 12px;
  background: var(--background-dark-08);
  backdrop-filter: blur(20px);
  box-sizing: border-box;
  height: 62px;
  margin: 16px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  letter-spacing: 0.04rem;
  white-space: nowrap;

  border-radius: var(--border-radius-16);
  border: 1px solid var(--background-dark-400);

  z-index: var(--z-index-root);

  color: #fff;

`

export default Navbar